import React, { useState } from 'react';
import { Card, Form, Switch, InputNumber, Button, Space, Alert, message } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';

const ContentProductConfig: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSave = async (values: any) => {
    setLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 800));
      message.success('内容配置已保存');
    } catch (error) {
      message.error('保存失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    form.resetFields();
    message.info('已重置为默认配置');
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="内容配置">
        <Alert
          type="info"
          showIcon
          message="内容访问规则"
          description="可配置未登录、已登录与VIP用户每日可观看内容数量；VIP可设置为无限。"
          style={{ marginBottom: 16 }}
        />
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
          initialValues={{
            guestEnabled: true,
            guestDailyLimit: 3,
            userDailyLimit: 10,
            vipUnlimited: true,
            vipDailyLimit: 100,
          }}
        >
          <Card size="small" title="未登录用户" style={{ marginBottom: 16 }}>
            <Form.Item label="是否允许查看内容" name="guestEnabled" valuePropName="checked">
              <Switch checkedChildren="允许" unCheckedChildren="禁止" />
            </Form.Item>
            <Form.Item label="每日可查看数量" name="guestDailyLimit">
              <InputNumber min={0} max={999} style={{ width: '100%' }} />
            </Form.Item>
          </Card>

          <Card size="small" title="已登录用户" style={{ marginBottom: 16 }}>
            <Form.Item label="每日可查看数量" name="userDailyLimit">
              <InputNumber min={0} max={999} style={{ width: '100%' }} />
            </Form.Item>
          </Card>

          <Card size="small" title="VIP用户" style={{ marginBottom: 16 }}>
            <Form.Item label="是否无限制" name="vipUnlimited" valuePropName="checked">
              <Switch checkedChildren="无限" unCheckedChildren="有限" />
            </Form.Item>
            <Form.Item label="每日可查看数量" name="vipDailyLimit">
              <InputNumber min={0} max={9999} style={{ width: '100%' }} />
            </Form.Item>
          </Card>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading}>
                保存配置
              </Button>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ContentProductConfig;







